import { useAlertContext } from "@shared";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { appointmentsApi } from "@/api";
import { QueryKey } from "@/query/Query";
import { useTranslation } from "@/translations";

interface AssignVariables {
  appointmentId: string;
  clientId: string;
}

export function useAssignAppointment() {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const { showSuccess } = useAlertContext();

  const mutation = useMutation({
    mutationFn: ({ appointmentId, clientId }: AssignVariables) =>
      appointmentsApi.assignClientToAppointment({
        appointmentId,
        assignClientToAppointmentRequest: { clientId },
      }),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: [QueryKey.Appointments] });
      showSuccess(t("calendar.assign1b.successMessage"));
    },
  });

  return {
    assign: mutation.mutate,
    isAssigning: mutation.isPending,
  };
}
